import React, { memo } from 'react';
import cx from 'classnames';

import { Loader } from 'components';

import { ButtonProps } from './types';

import styles from './styles.module.scss';

export const Button = memo((
  {
    isFullWidth,
    onClick,
    className,
    children,
    disabled,
    isLoading,
    isBgTransparent,
    isBigHeight,
    isGrayBg,
    color,
  }: ButtonProps,
) => {
  const getStyle = (): React.CSSProperties => {
    if (color === 'pink') {
      return { background: '#D154FB', border: '1px solid #D154FB' };
    }

    if (color === 'blue') {
      return {
        background:
          'linear-gradient(90deg, #4590E9 13%, #56B0DA 55%, #21EDEC 100%)',
        border: 'none',
      };
    }

    if (color === 'orange') {
      return { 
        background: 'linear-gradient(85.06deg, #ab3232 .89%, #ea6022)', 
        border: 'none',
      };
    }

    if (color === 'pinkTransparent') {
      return { background: 'transparent', border: '1px solid #D154FB' };
    }

    if (color === 'blueTransparent') {
      return { background: 'transparent', border: '1px solid #4590E9' };
    }

    if (color === 'none') {
      return { background: 'transparent', border: 'none' };
    }

    return { background: color, border: 'none' };
  };
  
  return (
    <button
      type="button"
      className={cx(
        className,
        styles.button,
        {
          [styles.full_width]: isFullWidth,
          [styles.disabled]: disabled,
          [styles.bg_transparent]: isBgTransparent,
          [styles.big_height]: isBigHeight,
          [styles.gray_color]: isGrayBg,
        },
      )}
      style={getStyle()}
      onClick={onClick}
      disabled={disabled || isLoading}
      aria-label="button"
    >
      {!isLoading && (
        <div className={cx(
          styles.button_content,
          { [styles.children_while_loading]: isLoading },
        )}
        >
          {children}
        </div>
      )}
      { isLoading && <Loader /> }
    </button>
  );
});
